module.exports = __webpack_public_path__ + "static/media/12b_hero_mobile.1cc6878a.jpg";